import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { NewMorphemeLessonLayoutContextValue } from "#new-morpheme-lesson-layout-context-value";

export const NewMorphemeLessonLayoutContext = createContext(
  defaultError<NewMorphemeLessonLayoutContextValue>("NewMorphemeLessonLayoutContext"),
);
